"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./verticalSelectList.less");
var button_1 = require("spry-react/Buttons/button");
var VerticalSelectList = /** @class */ (function (_super) {
    __extends(VerticalSelectList, _super);
    function VerticalSelectList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VerticalSelectList.prototype.render = function () {
        return React.createElement("ul", { className: "vertical-edit-menu list-unstyled" }, this.props.children);
    };
    return VerticalSelectList;
}(React.Component));
exports.VerticalSelectList = VerticalSelectList;
var VerticalSelectListItem = /** @class */ (function (_super) {
    __extends(VerticalSelectListItem, _super);
    function VerticalSelectListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VerticalSelectListItem.prototype.render = function () {
        return React.createElement("li", { className: this.props.selected ? "active" : "", onContextMenu: this.props.onContextMenu }, this.props.children);
    };
    return VerticalSelectListItem;
}(React.Component));
exports.VerticalSelectListItem = VerticalSelectListItem;
function renderAddButton(props) {
    return React.createElement(button_1.EditorGridAddButton, { title: props.title, disabled: props.disabled, onClick: props.onClick, focusRef: props.focusRef }, props.label);
}
var VerticalSelectListButton = /** @class */ (function (_super) {
    __extends(VerticalSelectListButton, _super);
    function VerticalSelectListButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VerticalSelectListButton.prototype.render = function () {
        return (React.createElement("div", { style: { display: 'flex', marginTop: '0.5rem' } }, renderAddButton(this.props)));
    };
    return VerticalSelectListButton;
}(React.Component));
exports.VerticalSelectListButton = VerticalSelectListButton;
var VerticalSelectListButtonStack = /** @class */ (function (_super) {
    __extends(VerticalSelectListButtonStack, _super);
    function VerticalSelectListButtonStack() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VerticalSelectListButtonStack.prototype.render = function () {
        return React.createElement("ul", { className: "vertical-edit-menu list-unstyled" }, this.props.buttons.map(function (b) {
            return React.createElement("li", null, renderAddButton(b));
        }));
    };
    return VerticalSelectListButtonStack;
}(React.Component));
exports.VerticalSelectListButtonStack = VerticalSelectListButtonStack;
